import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

// detect user interface language and load relevant translation
const parts = document.location.pathname.split('/');
export const lang = parts[2] ? parts[2].toLowerCase() : 'en';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: lang,
    fallbackLng: 'en',
    debug: false,
    backend: {
      /* translation file path */
      loadPath: '/sa/ar/booking/assets/i18n/{{ns}}/{{lng}}.json'
    },
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      useSuspense: true
    }
  });

export default i18n;
